import type { StaleReason } from "@/types/bids"

/** Why this bid needs another look — plan republished past its sync, or a
 *  pinned template with a newer version. Server-derived reasons, worded
 *  here; never a stored status. */
export function StalenessBanner({ reasons }: { reasons: StaleReason[] }) {
  if (reasons.length === 0) return null

  return (
    <div className="callout-signal mt-4" data-testid="stale-banner">
      <p>
        <strong className="text-inherit">Rebid needed.</strong>{" "}
        {reasons
          .map((reason) =>
            reason.kind === "plan_republished"
              ? `${reason.label}'s master takeoff was republished — re-sync its quantities.`
              : `The ${reason.label} order template has a newer version — review the pin.`
          )
          .join(" ")}{" "}
        Margins update as inputs change; quoted prices never move on their own.
      </p>
    </div>
  )
}
